module.exports = __webpack_public_path__ + "img/penance.b14a3129.png";